/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreMetrics
 */
export interface StoreMetrics {
    /**
     * 
     * @type {number}
     * @memberof StoreMetrics
     */
    storeCount: number;
    /**
     * 
     * @type {number}
     * @memberof StoreMetrics
     */
    activeStoreCount: number;
}

/**
 * Check if a given object implements the StoreMetrics interface.
 */
// @ts-ignore
export function instanceOfStoreMetrics(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "storeCount" in value;
    isInstance = isInstance && "activeStoreCount" in value;

    return isInstance;
}

// @ts-ignore
export function StoreMetricsFromJSON(json: any): StoreMetrics {
    return StoreMetricsFromJSONTyped(json, false);
}

// @ts-ignore
export function StoreMetricsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreMetrics {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'storeCount': json['store_count'],
        'activeStoreCount': json['active_store_count'],
    };
}

// @ts-ignore
export function StoreMetricsToJSON(value?: StoreMetrics | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'store_count': value.storeCount,
        'active_store_count': value.activeStoreCount,
    };
}

